import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Content to display next to or below the icon */
  children: PropTypes.node.isRequired,
  /** Icon element to display (use the icon component) */
  icon: PropTypes.element.isRequired,
  /** Vertical alignment of the icon (only for horizontal orientation) */
  alignIcon: PropTypes.oneOf(['top', 'center']),
  /** Layout direction for icon and content */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
function IconBlock(_ref) {
  var _ref$alignIcon = _ref.alignIcon,
    alignIcon = _ref$alignIcon === void 0 ? 'center' : _ref$alignIcon,
    children = _ref.children,
    icon = _ref.icon,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-block",
    "data-orientation": orientation,
    "data-align-icon": orientation === 'horizontal' ? alignIcon : null,
    "data-testid": "icon-block"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "icon-block-icon",
    "data-testid": "icon-block-icon"
  }, icon), /*#__PURE__*/React__default.createElement("div", {
    className: "icon-block-content"
  }, children));
}
IconBlock.propTypes = propTypes;

export { IconBlock as default };
//# sourceMappingURL=IconBlock.js.map
